import "../style/ResultBox.css";
export default function ResultBox({ setPageState, gamestate, setGameState }) {
    const HandleRetry = () => {
        setGameState((prev) => ({
            ...prev,
            words: [...prev.words.slice(prev.currentWordIndex), ...prev.wrongAnswers],
            currentWordIndex: 0,
        }));

        setPageState("gameplay");
    };

    return (
        <div className="result-container">
            <div className="result-area">
                <h1>Game Over!</h1>
                <p>Your Score: {gamestate.correctAnswers} / {gamestate.words.length}</p>

                <div className="result-options">
                    <button className="btn btn-primary" onClick={() => setPageState("setup")}>
                        Home
                    </button>


                    {gamestate.wrongAnswers.length > 0 && (
                        <button className="btn btn-primary" onClick={() => HandleRetry()}>
                            Retry Wrong Answers
                        </button>
                    )}
                </div>
            </div>
         </div>
    );
}